/* build: cart recs + drawer recs (two surfaces) */
/* basket on UK paths, cart on /en-* market paths - merchant decision
   25 Aug 2026; same rule as snippets/kp-cart-term.liquid. */
var KP_CART_TERM = /^\/[a-z]{2}-[a-z]{2}\//.test(location.pathname) ? 'cart' : 'basket';

/* ============================================================
   CART DRAWER
   Contents are always re-rendered server-side from
   sections/cart-drawer.liquid via the Section Rendering API, so
   there is no duplicate cart maths in JS to drift from Liquid.
   All listeners are delegated on `document` so they survive the
   innerHTML swap when the drawer re-renders.
   ============================================================ */
(function () {
  var themeStrings = (window.KPTheme && window.KPTheme.strings) || {
    adding: 'Adding…',
    addError: 'This item could not be added. Please check your selection and try again.',
    addUncertain: 'We could not confirm the add. Please check your ' + KP_CART_TERM + ' before trying again.',
    addedRefreshError: 'Item added, but the ' + KP_CART_TERM + ' preview could not refresh. View your ' + KP_CART_TERM + ' to confirm.',
    viewCart: 'View ' + KP_CART_TERM,
    cartError: 'There was an error while updating your bag. Please try again.'
  };
  var SECTION = 'cart-drawer';
  var seq = 0, applied = 0;
  /* Shopify.routes.root is set by content_for_header; fall back to '/' so a
     missing global can never throw and break add-to-cart entirely. */
  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function fetchWithTimeout(url, options, ms) {
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, ms || 12000);
    return fetch(url, Object.assign({}, options, { signal: controller.signal }))
      .finally(function () { clearTimeout(timer); });
  }

  function drawer()  { return document.getElementById('kp-drawer'); }
  function overlay() { return document.getElementById('kp-drawer-overlay'); }
  function track(eventName, properties) {
    if (window.KPTheme && typeof window.KPTheme.track === 'function') {
      window.KPTheme.track(eventName, properties || {});
    }
  }

  /* Compact was tried to collapse dead space when recs are off, but:
     (1) applying it BEFORE loadRecs measured free space made body.clientHeight
         ≈ items only, free < 112, and recs never painted until full page refresh;
     (2) packing the footer mid-panel left a tall empty void under View bag on
         desktop and moved Secure checkout off the thumb zone.
     Foot stays flex-pinned to the bottom of the drawer (always in reach).
     Recs free-space is measured from the drawer shell, not the body height. */

  /* Focus trap + restoration: lastTrigger is the opener close() returns
     focus to instead of <body>. */
  var lastTrigger = null;
  var FOCUSABLE_SEL = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"]),shopify-accelerated-checkout,shopify-accelerated-checkout-cart';
  function getFocusable(el) {
    return Array.prototype.filter.call(
      el.querySelectorAll(FOCUSABLE_SEL),
      function (n) { return n.offsetParent !== null || n === document.activeElement; }
    );
  }

  function showCartFeedback(message, tone) {
    var feedback = drawer() && drawer().querySelector('[data-cart-feedback]');
    if (!feedback) return;
    feedback.textContent = message || '';
    feedback.hidden = !message;
    feedback.setAttribute('data-tone', tone || 'error');
  }

  function showFormFeedback(form, message, tone, includeCartLink) {
    var feedback = form.querySelector('[data-product-form-feedback]');
    if (!feedback) {
      feedback = document.createElement('div');
      feedback.className = 'product-form-feedback';
      feedback.setAttribute('data-product-form-feedback', '');
      feedback.setAttribute('role', 'status');
      feedback.setAttribute('aria-live', 'polite');
      form.appendChild(feedback);
    }
    feedback.replaceChildren(document.createTextNode(message || ''));
    if (message && includeCartLink) {
      var link = document.createElement('a');
      link.href = root() + 'cart';
      link.className = 'product-form-feedback__link';
      link.textContent = themeStrings.viewCart;
      feedback.appendChild(link);
    }
    feedback.hidden = !message;
    feedback.setAttribute('data-tone', tone || 'error');
  }

  function open(trigger) {
    var d = drawer(), o = overlay();
    if (!d || !o) return;
    lastTrigger = trigger || document.activeElement || null;
    o.hidden = false;
    d.removeAttribute('inert');
    // next frame so the transition runs from the closed state
    requestAnimationFrame(function () {
      d.classList.add('is-open'); o.classList.add('is-open');
    });
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('kp-drawer-open');
    if (window.KPTheme && typeof window.KPTheme.lockBody === 'function') {
      window.KPTheme.lockBody('cart');
    }
    var c = d.querySelector('[data-drawer-close]'); if (c) c.focus();
    loadRecs('drawer');
    track('cart_drawer_open');
  }

  /* Complementary products for the empty area under a short cart.

     Fired from open(), not on page load: the request is worthless until the
     drawer is actually on screen, and firing it at load would put a fetch on
     the critical path of every page for a panel most visitors never open.

     S.seed guards against refetching for the same seed product each time
     the drawer is reopened, while still refreshing if the first cart line
     changes. Failures are swallowed on purpose - the container stays hidden
     and the drawer is exactly what it was before, which is the correct
     degradation for a nice-to-have. */
  /* Recommendation strips, shared by two surfaces.

     The cart PAGE has vertical room the drawer does not, so it is not space
     gated and shows up to four; the drawer fills only genuine dead space and
     measures for it. Everything else - sourcing, the in-cart and substitute
     filters, the one-per-order suppression, variant handling - is identical
     and lives here once rather than being copied into main-cart.liquid. */
  /* Premier League fan-gear catalogue, used to fill Taylors drawer/cart
     recs the same way related-products.liquid fills from
     collections.premier-football-fan-gifts. Shopify's related API often
     returns other clubs; without this fill the strip cannot show 3 City
     items when a City ball is in the bag. Cached after first open. */
  var taylorsCatalog = null;
  function variantPriceCents(vr) {
    var price = vr && vr.price;
    if (typeof price === 'number') return price;
    if (typeof price === 'string') return Math.round(parseFloat(price) * 100) || 0;
    return 0;
  }
  function normalizeAjaxProduct(p) {
    if (!p) return p;
    var variants = p.variants || [];
    var available = typeof p.available === 'boolean'
      ? p.available
      : variants.some(function (vr) { return !!vr.available; });
    var img = p.featured_image;
    if (img && typeof img === 'object') img = img.src || img.url || '';
    if (!img && p.images && p.images[0]) {
      img = typeof p.images[0] === 'string' ? p.images[0] : (p.images[0].src || '');
    }
    var url = p.url || (p.handle ? (root() + 'products/' + p.handle) : '');
    var opts = p.options || [];
    if (opts.length && typeof opts[0] === 'string') {
      opts = opts.map(function (name) { return { name: name }; });
    }
    return {
      id: p.id,
      title: p.title,
      handle: p.handle,
      vendor: p.vendor,
      type: p.type || p.product_type,
      product_type: p.product_type || p.type,
      tags: p.tags,
      available: available,
      featured_image: img,
      url: url,
      options: opts,
      variants: variants.map(function (vr) {
        return {
          id: vr.id,
          title: vr.title,
          price: variantPriceCents(vr),
          available: vr.available,
          option1: vr.option1,
          option2: vr.option2,
          option3: vr.option3
        };
      })
    };
  }
  function getTaylorsCatalog() {
    if (taylorsCatalog) return Promise.resolve(taylorsCatalog);
    return fetchWithTimeout(root() + 'collections/premier-football-fan-gifts/products.json?limit=250', {
      headers: { 'Accept': 'application/json' }
    }, 12000)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var list = ((d && d.products) || []).map(normalizeAjaxProduct);
        if (list.length) taylorsCatalog = list;
        return list;
      })
      .catch(function () { return []; });
  }

  var SURFACES = {
    drawer: {
      boxId: 'kp-drawer-recs', listId: 'kp-drawer-recs-list',
      itemSel: '#kp-drawer .kp-ditem', nameSel: '#kp-drawer .kp-ditem__name',
      bodySel: '#kp-drawer .kp-drawer__body',
      measure: true, max: 2, seed: null, retried: 0, loading: null, html: null, htmlSeed: null
    },
    cart: {
      boxId: 'kp-cart-recs', listId: 'kp-cart-recs-list',
      itemSel: '#kp-cart-form .kp-cart-item', nameSel: '#kp-cart-form .kp-cart-item__name',
      bodySel: null,
      measure: false, max: 2, seed: null, retried: 0, loading: null, html: null, htmlSeed: null
    }
  };

  /* The invalidation contract for the render cache.

     S.html was written but never cleared, and the seed cannot substitute for
     invalidation: the strip lives inside .kp-drawer__body, so every refresh
     delivers a fresh seed that still MATCHES whenever line 1 is unchanged.
     The repaint is a raw innerHTML write that never re-runs the in-bag
     exclusion, so: cart holds A, hover warms a cache containing B, add B, and
     the repaint puts B's card back with a live Add button one row under B in
     the bag. Tapping it silently takes B to quantity 2.

     Root cause of this whole round: state was added for performance (cache,
     warm) without a contract saying when it dies. This is that contract -
     called wherever the cart actually mutates, so the class is closed rather
     than the instance. */
  function invalidateRecsCache() {
    SURFACES.drawer.html = SURFACES.drawer.htmlSeed = null;
    SURFACES.cart.html = SURFACES.cart.htmlSeed = null;
  }

  function loadRecs(key) {
    var S = SURFACES[key || 'drawer'];
    if (!S) return;
    var box = document.getElementById(S.boxId);
    if (!box) return;
    var seed = box.getAttribute('data-seed');
    if (!seed) return;
    /* Guard on "already populated", not on the seed alone. refresh() re-renders
       the drawer from ?section_id, which restores the container to its empty
       hidden state - keying only on the seed meant the refetch was skipped and
       the recommendations never came back for the rest of the session. */
    var liveList = document.getElementById(S.listId);

    /* Instant re-paint from cache, before anything async.

       refresh() replaces the drawer, which resets this container to empty and
       hidden, and the strip only came back when a fresh fetch landed. For the
       few hundred ms in between the shopper saw it vanish and return - the
       "appear, disappear, appear" flicker. The markup does not depend on the
       cart, only on the seed product, so when the seed is unchanged the
       previous render can be put straight back synchronously. The guard below
       then returns before any network call: same seed, same cards, no flash
       and no request. */
    if (liveList && !liveList.children.length && S.html && S.htmlSeed === seed) {
      liveList.innerHTML = S.html;
      box.hidden = false;
    }

    if (seed === S.seed && liveList && liveList.children.length) return;
    /* In-flight latch. The populated-guard above cannot see a request that has
       not landed yet, so open() and refresh() - which both call loadRecs -
       each started their own pair of intent fetches for the same seed.
       Measured: four requests per drawer open where two are needed. */
    if (S.loading === seed) return;
    S.loading = seed;
    S.seed = seed;

    /* Both intents. Complementary is the better suggestion (it is merchandised
       in Search & Discovery) but is set on only a handful of products, so on
       its own it yields one card or none. Related fills the remainder and is
       available catalogue-wide. */
    function recUrl(intent) {
      return root() + 'recommendations/products.json?product_id=' +
             encodeURIComponent(seed) + '&limit=8&intent=' + intent;
    }
    function getRecs(intent) {
      return fetchWithTimeout(recUrl(intent), { headers: { 'Accept': 'application/json' } }, 12000)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { return (d && d.products) || []; })
        .catch(function () { return []; });
    }

    /* Related suppressed for one-per-order product types. Nobody buys a second
       wall bed, bunk bed or nursery chair, so "you may also like" cannot add a
       unit - but it CAN cost one, by reopening a GBP300-1,080 comparison the
       shopper had just closed. Complementary only for those; hidden if none. */
    var seedType = (box.getAttribute('data-seed-type') || '').trim().toLowerCase();
    var singles = (box.getAttribute('data-single-types') || '').split(',')
                    .map(function (t) { return t.trim().toLowerCase(); })
                    .filter(Boolean);
    var singleOnly = seedType && singles.some(function (s) {
      return seedType.indexOf(s) !== -1 || s.indexOf(seedType) !== -1;
    });

    /* Probe layout BEFORE fetching, not after.

       The measurement used to sit inside the .then, so every no-layout retry
       re-downloaded both recommendation intents - a slow open could cost up to
       20 requests to answer a question that needs none of them. This is the
       same mistake as measuring scrollHeight after rendering into it: do the
       cheap check first. The full measurement still runs after the fetch,
       where the card count is decided; this one only answers "is the panel
       laid out yet?". */
    if (S.measure) {
      var probe = document.querySelector(S.bodySel);
      if (!probe || probe.clientHeight === 0) {
        S.retried = (S.retried || 0) + 1;
        /* Clear the latch on BOTH paths (23 Aug 2026). S.loading = seed is set
           further up, before this probe. Releasing it only inside the retry
           branch meant the 11th failure returned with the latch still held, and
           nothing else clears it: the .then tail belongs to a Promise chain
           this early return never reaches, and refresh(), the pageshow handler
           and the kp:cart-recommendations-refresh listener are all gated by the
           S.loading === seed check that runs before their resets. Result was a
           blank cross-sell strip for the rest of the pageview. Reachable today,
           not hypothetically: on a phone in landscape the drawer's fixed chrome
           exceeds the shell, .kp-drawer__body measures clientHeight 0, and
           warmRecs() firing on touchstart burns all 11 probes in ~1.1s.
           S.retried is still only reset by refresh()/pageshow/rec-add, so the
           retry bound is unchanged. */
        S.seed = null;
        S.loading = null;
        if (S.retried <= 10) {
          setTimeout(function () { loadRecs(key); }, 100);
        }
        return;
      }
    }

    var seedVendorHint = (box.getAttribute('data-seed-vendor') || '').toLowerCase();
    Promise.all([
      getRecs('complementary'),
      singleOnly ? [] : getRecs('related'),
      seedVendorHint === 'taylors' ? getTaylorsCatalog() : []
    ])
      .then(function (sets) {
        var items = sets[0].concat(sets[1]);
        if (sets[2] && sets[2].length) items = items.concat(sets[2]);
        if (!items.length) return;
        /* Re-query BOTH nodes here, never reuse the `box` captured above:
           refresh() replaces the drawer via ?section_id while this fetch is in
           flight, so the element we started with may already be detached. */
        var liveBox = document.getElementById(S.boxId);
        var list = document.getElementById(S.listId);
        if (!liveBox || !list) return;
        if (liveBox.getAttribute('data-seed') !== seed) return;
        var seedVendor = (liveBox.getAttribute('data-seed-vendor') || '').toLowerCase();
        var seedTitle = '';
        var seedNameEl = document.querySelector(S.nameSel);
        if (seedNameEl) seedTitle = (seedNameEl.textContent || '').trim();
        function recTags(p) {
          var tags = p.tags || [];
          if (typeof tags === 'string') tags = tags.split(/,\s*/);
          return tags;
        }
        function recIsTaylors(p) {
          if (String(p.vendor || '').toLowerCase() === 'taylors') return true;
          var tags = recTags(p);
          for (var ti = 0; ti < tags.length; ti++) {
            if (String(tags[ti]).toLowerCase() === 'taylors') return true;
          }
          return false;
        }
        function taylorsTeamOf(p) {
          var tags = recTags(p);
          for (var ti = 0; ti < tags.length; ti++) {
            var tl = String(tags[ti]).toLowerCase();
            if (/\sfc\b/.test(tl) || /\sru\b/.test(tl) || /rfc\b/.test(tl)) return tl;
          }
          var m = String((p && p.title) || '').match(/^(.+?\s(?:FC|RU|RFC))\b/i);
          return m ? m[1].toLowerCase() : '';
        }
        function taylorsKindOf(p) {
          var t = String(p.product_type || p.type || '').toLowerCase();
          if (/tedd|soft toy|plush|unicorn/.test(t)) return 'bear';
          if (/bag|backpack|luggage|messenger/.test(t)) return 'bag';
          if (/ball/.test(t)) return 'ball';
          return t;
        }
        if (seedVendor === 'taylors') {
          items = items.filter(recIsTaylors);
          var seedTeamMatch = seedTitle.match(/^(.+?\s(?:FC|RU|RFC))\b/i);
          var seedTeam = seedTeamMatch ? seedTeamMatch[1].toLowerCase() : '';
          var seedKind = taylorsKindOf({ product_type: seedType });
          items.sort(function (a, b) {
            function score(p) {
              var s = 0;
              if (seedTeam && taylorsTeamOf(p) === seedTeam) s += 4;
              if (seedKind && taylorsKindOf(p) === seedKind) s += 2;
              return s;
            }
            return score(b) - score(a);
          });
        }

        var seen = {};
        document.querySelectorAll(S.itemSel).forEach(function (el) {
          var id = el.getAttribute('data-product-id'); if (id) seen[id] = 1;
        });
        /* If the catalogue has enough of the same club (excluding the line
           already in the bag), do not fill remaining slots with other teams. */
        if (seedVendor === 'taylors' && seedTeam) {
          var teamOnly = items.filter(function (p) {
            return !seen[String(p.id)] && taylorsTeamOf(p) === seedTeam;
          });
          if (teamOnly.length >= (S.max || 3)) items = teamOnly;
        }
        /* Cart titles reduced to their first three words, to spot
           recommendations that are really the same product in another size.
           "Cerruti 1881 Eau de Toilette 200ml" in the bag was pulling the
           100ml and 50ml of the same fragrance - cheaper substitutes for the
           thing they had already chosen, which invites trading DOWN rather
           than adding on. Different products survive this: the pregnancy
           pillow's "12ft U-Shaped Pregnancy Pillow Replacement Cover" does
           not share a stem with "Full Body Pregnancy Pillow with Washable
           Cover", so the genuine complement is still offered. */
        function stem(t) {
          return String(t || '').toLowerCase().replace(/[^a-z0-9 ]/g, ' ')
                 .split(/\s+/).filter(Boolean).slice(0, 3).join(' ');
        }
        /* Beautyfort PDPs only: same fragrance line, different bottle sizes
           are separate products. Never recommend two of them side by side
           (Noir Extreme 50ml + 150ml) or vs what is already in the bag. */
        function isBeautyfort(p) {
          var tags = p.tags || [];
          if (typeof tags === 'string') {
            tags = tags.split(/,\s*/);
          }
          for (var ti = 0; ti < tags.length; ti++) {
            if (String(tags[ti]).toLowerCase() === 'beautyfort') return true;
          }
          return false;
        }
        var cartStems = [];
        document.querySelectorAll(S.nameSel).forEach(function (el) {
          var st = stem(el.textContent); if (st) cartStems.push(st);
        });
        var shownFragranceStems = {};
        /* Only fill genuine dead space under the line items.

           free is measured from the DRAWER SHELL, not .kp-drawer__body height.
           Body is flex:1 and can be mid-reflow after refresh(); using its
           clientHeight right after add-to-cart falsely reported free < 112
           (especially after a brief compact class experiment) and skipped
           the strip until a full page reload. Shell math:
             free = drawerH - head - ship - foot - itemsH - pad
           Cards need ~112px with heading before the first is worth showing. */
        var lines = document.querySelectorAll(S.itemSel);
        var cap = S.max;
        if (S.measure) {
          var dEl = drawer();
          var bodyEl = S.bodySel ? document.querySelector(S.bodySel) : null;
          var shellH = dEl ? dEl.clientHeight : 0;
          if (shellH > 0) {
            var itemsH = 0;
            lines.forEach(function (el) { itemsH += el.offsetHeight; });
            var headEl = dEl.querySelector('.kp-drawer__head');
            var shipEl = dEl.querySelector('.kp-drawer__ship');
            var footEl = dEl.querySelector('.kp-drawer__foot');
            var chrome = (headEl ? headEl.offsetHeight : 0) +
              (shipEl ? shipEl.offsetHeight : 0) +
              (footEl ? footEl.offsetHeight : 0);
            var free = shellH - chrome - itemsH - 24;
            if (free < 112) return;
            cap = S.max;
          } else {
            /* Drawer not laid out yet — retry (bounded). */
            S.retried = (S.retried || 0) + 1;
            if (S.retried <= 10) {
              S.seed = null;
              S.loading = null;
              setTimeout(function () { loadRecs(key); }, 100);
            }
            return;
          }
        }

        var shown = 0, html = '';
        items.forEach(function (p) {
          if (shown >= cap || seen[String(p.id)] || !p.available) return;
          var pStem = stem(p.title);
          /* 3-word stem is a perfume same-size skip ("Cerruti 1881 Eau…").
             Fan-gear titles share a club prefix ("Manchester City FC …"), so
             applying it to Taylors drops every other City SKU and leaves
             other teams. Exact product-id exclusion above still hides the
             line already in the bag. */
          if (seedVendor !== 'taylors' && cartStems.indexOf(pStem) !== -1) return;
          /* Beautyfort: one size per fragrance line in the strip. Cart stems
             already block sizes of what is in the bag; this blocks two sizes
             of a *different* scent both appearing as recommendations. */
          if (isBeautyfort(p) && pStem) {
            if (shownFragranceStems[pStem]) return;
            shownFragranceStems[pStem] = 1;
          }
          /* When complementary recs exist, drop same-type related substitutes
             (e.g. another pregnancy pillow) so the cover/accessory leads.
             Skip for Taylors: complementary is often the wrong department,
             and same-kind (another City ball) is the wanted card. */
          if (seedVendor !== 'taylors' && sets[0].length && seedType &&
              String(p.type || p.product_type || '').toLowerCase() === seedType) return;
          /* First AVAILABLE variant, not variants[0].

             Sold-out options are listed but `disabled`, which stops the
             shopper CHOOSING one - it does not stop the browser from
             default-selecting it when it happens to be first. So a product
             whose first variant is out of stock rendered a card that looked
             orderable, priced off the sold-out variant, and posted it on Add:
             cart/add.js 422s and the shopper who never touched the select is
             told "Sorry, that could not be added". Exactly the Leg Elevation
             Pillow case one restock cycle later. */
          var allVariants = p.variants || [];
          var v = null;
          for (var vi = 0; vi < allVariants.length; vi++) {
            if (allVariants[vi].available) { v = allVariants[vi]; break; }
          }
          if (!v) v = allVariants[0];
          if (!v) return;
          seen[String(p.id)] = 1;

          /* eager, not lazy: these <img> elements are created only when the
             drawer opens, so they are always about to enter the viewport.
             Lazy loading just bought a visible blank square on every open. */
          /* Same separator discipline as predictive-search.js:86 and
             product-controller.js:296 - a CDN URL without ?v= would otherwise
             get a malformed '&width'. */
          var img = '';
          if (p.featured_image) {
            img = p.featured_image + (p.featured_image.indexOf('?') === -1 ? '?' : '&') + 'width=160';
          }
          var imgTag = img
            ? '<img src="' + escapeHtml(img) + '" alt="" loading="eager" decoding="async" width="56" height="56">'
            : '';

          /* Variant handling, three cases.

             Posting variants[0] blind was wrong: on the Leg Elevation Pillow
             it silently picked Standard Foam over memory foam and the shopper
             only found out on delivery. But sending every multi-variant
             product to its page is the other extreme - it throws away the one
             thing the drawer is for, which is adding without leaving the page.

             So: one option (Foam type, Size) gets an inline <select> and keeps
             the one-tap Add. Two or more options (size AND colour) still go to
             the product page, because a row of selects in a 56px card is worse
             than the page that was built for it. Single-variant products are
             unchanged. */
          var variants = p.variants || [];
          var opts = p.options || [];
          var optionCount = opts.length;
          var inline = variants.length > 1 && optionCount === 1;
          var toPage = variants.length > 1 && optionCount > 1;

          var priceLabel = variants.length > 1 ? 'From ' + money(v.price) : money(v.price);
          var selectHtml = '';
          if (inline) {
            /* Sold-out variants stay listed but disabled: silently dropping
               them makes the shopper think the size they want never existed. */
            selectHtml = '<select class="kp-drec__variant" aria-label="' +
              escapeHtml(opts[0].name || 'Option') + '">';
            variants.forEach(function (vr) {
              selectHtml += '<option value="' + vr.id + '" data-price="' + vr.price + '"' +
                (vr.available ? '' : ' disabled') +
                /* Explicit selected on the variant the card is priced from,
                   so the browser cannot default to a disabled first option. */
                (vr.id === v.id ? ' selected' : '') + '>' +
                escapeHtml(vr.title) + (vr.available ? '' : ' - sold out') + '</option>';
            });
            selectHtml += '</select>';
          }

          var action = toPage
            ? '<a class="kp-drec__add" href="' + escapeHtml(p.url) + '">Choose</a>'
            : '<button type="button" class="kp-drec__add" data-rec-add="' + v.id + '">Add</button>';

          html += '<div class="kp-drec' + (inline ? ' kp-drec--has-variant' : '') + '">' +
            '<a class="kp-drec__img" href="' + escapeHtml(p.url) + '">' + imgTag + '</a>' +
            '<div class="kp-drec__meta">' +
              '<a class="kp-drec__title" href="' + escapeHtml(p.url) + '">' + escapeHtml(p.title) + '</a>' +
              '<div class="kp-drec__offer">' +
                '<span class="kp-drec__price">' + priceLabel + '</span>' +
                selectHtml +
              '</div>' +
            '</div>' +
            action +
          '</div>';
          shown++;
        });
        if (!shown) return;
        list.innerHTML = html;
        liveBox.hidden = false;
        /* Cached against the seed it was built from, so a different first
           cart line always rebuilds rather than re-showing stale cards. */
        S.html = html;
        S.htmlSeed = seed;
      })
      .catch(function () { /* silent - the surface is unchanged */ })
      .then(function () { S.loading = null; });
  }
  function close() {
    var d = drawer(), o = overlay();
    if (!d || !o) return;
    d.classList.remove('is-open'); o.classList.remove('is-open');
    /* Focus must leave the drawer before inert is set, or it force-blurs to <body>. */
    if (document.activeElement && d.contains(document.activeElement)) {
      if (lastTrigger && lastTrigger.isConnected) {
        lastTrigger.focus({ preventScroll: true });
      } else {
        document.activeElement.blur();
      }
    }
    d.setAttribute('aria-hidden', 'true');
    d.setAttribute('inert', '');
    document.body.classList.remove('kp-drawer-open');
    if (window.KPTheme && typeof window.KPTheme.unlockBody === 'function') {
      window.KPTheme.unlockBody('cart');
    }
    lastTrigger = null;
    setTimeout(function () { if (!d.classList.contains('is-open')) o.hidden = true; }, 300);
  }

  /* Re-render from the server. Late responses are dropped so a slow
     earlier request can never overwrite newer cart state. */
  function refresh(thenOpen) {
    var mine = ++seq;
    return fetchWithTimeout(root() + '?section_id=' + SECTION, { headers: { 'Accept': 'text/html' } }, 12000)
      .then(function (r) { if (!r.ok) throw new Error('section fetch ' + r.status); return r.text(); })
      .then(function (html) {
        /* A newer request already landed and rendered. Dropping this stale
           response is the CORRECT outcome, not a failure — return true so the
           caller doesn't show the shopper a cart error for a race we won.
           Returning undefined here made every overlapping refresh surface
           "There was an error while updating your bag" over a cart that was
           in fact perfectly up to date. */
        if (mine < applied) return true;
        applied = mine;
        var host = document.getElementById('shopify-section-' + SECTION);
        if (!host) return false;
        var wasOpen = drawer() && drawer().classList.contains('is-open');
        var fresh = new DOMParser().parseFromString(html, 'text/html')
          .getElementById('shopify-section-' + SECTION);

        /* Replace the cart-dependent regions in place; never re-render the
           wallet container.

           Blowing away host.innerHTML re-rendered
           content_for_additional_checkout_buttons, so Shopify's wallet web
           components had to re-register on every add-to-cart - the visible
           disappear/reappear the merchant reported.

           This is NOT the preserve-and-transplant approach: that detaches the
           hydrated node and re-adopts it, which is exactly the manoeuvre whose
           safety nobody could vouch for. Here the wallet container is simply
           never touched - no detach, no re-adoption, no re-registration -
           which is identical in semantics to patchDrawer()'s quantity path
           that has been running safely since this batch shipped.

           Safe because the merchant confirmed on this store that changing a
           quantity (patch path, wallet never re-rendered) and then tapping a
           wallet shows the UPDATED total: these components read the cart at
           click time against the server-side cart token, not at registration.

           Any structural change - the cart emptying, the footer appearing or
           disappearing - falls back to the full swap, because then there is no
           live wallet worth protecting anyway. */
        /* [data-cart-feedback] is in here deliberately. It sits between the
           head and the body, so the targeted swap missed it - and where the
           old full innerHTML swap wiped any visible error on every refresh,
           the targeted one preserved it. A failed quantity change's "There
           was an error while updating your bag" then survived a later
           SUCCESSFUL add and sat over a perfectly healthy cart. */
        var REGIONS = ['.kp-drawer__head', '[data-cart-feedback]',
                       '.kp-drawer__ship', '.kp-drawer__body',
                       '.kp-dsave', '.kp-dsub'];
        var liveWallet = host.querySelector('.kp-dexpress');
        var freshWallet = fresh.querySelector('.kp-dexpress');
        var canPatch = !!(liveWallet && freshWallet);
        if (canPatch) {
          for (var ri = 0; ri < REGIONS.length; ri++) {
            var liveEl = host.querySelector(REGIONS[ri]);
            var freshEl = fresh.querySelector(REGIONS[ri]);
            /* Both sides must have it, or the structure changed under us. */
            if (!liveEl !== !freshEl) { canPatch = false; break; }
          }
        }
        if (canPatch) {
          REGIONS.forEach(function (sel) {
            var liveEl = host.querySelector(sel);
            var freshEl = fresh.querySelector(sel);
            if (liveEl && freshEl) liveEl.replaceWith(freshEl);
          });
        } else {
          host.innerHTML = fresh.innerHTML;
        }
        if (wasOpen || thenOpen) {
          var d = drawer(), o = overlay();
          if (d && o) {
            o.hidden = false;
            d.removeAttribute('inert');
            d.setAttribute('aria-hidden', 'false');
            document.body.classList.add('kp-drawer-open');
            if (window.KPTheme && typeof window.KPTheme.lockBody === 'function') {
              window.KPTheme.lockBody('cart');
            }

            /* is-open on the NEXT frame, exactly as open() does it.

               Adding it synchronously here made add-to-cart pop the drawer
               into place while the cart icon slid it in. The innerHTML swap
               above replaces the panel, so the element is brand new: setting
               the open class in the same frame means it is never painted in
               its closed state, the transition has no start value to animate
               from, and it jumps straight to the end. Already-open refreshes
               (wasOpen) are unaffected either way - the class is already on.

               Animate ONLY when the panel was shut before this refresh, and
               test that with `wasOpen`, captured above the innerHTML swap.
               Testing the live element cannot work: the swap replaces it, so
               the new node never carries is-open and every refresh animated -
               which made adding a second item to an already-open drawer slide
               it in a second time. */
            if (wasOpen) {
              d.classList.add('is-open');
              o.classList.add('is-open');
            } else {
              /* Re-query inside the callback, and let close() win.

                 Three failures live in the <=16ms between scheduling this and
                 it firing, all fixed by not trusting the captured nodes:

                 1. A second winning refresh detaches d/o, so the class-add
                    paints nothing (harmless, but it is the liveBox bug again).
                 2. Worse: that second refresh reads `wasOpen` off a panel
                    whose is-open is still pending in THIS unfired callback,
                    sees false, and schedules its own slide - the double-slide
                    returns for two refreshes landing within a frame (an
                    add-to-cart racing a qty reconcile). Re-querying makes the
                    late callback act on the live panel, which is what the
                    second refresh wanted anyway, so its slide is redundant
                    rather than additive.
                 3. close() inside the window removes classes that are not
                    there yet; the late callback would then re-open an inert,
                    aria-hidden panel. The inert gate makes close() win. */
              requestAnimationFrame(function () {
                var dd = drawer(), oo = overlay();
                if (dd && oo && !dd.hasAttribute('inert')) {
                  dd.classList.add('is-open');
                  oo.classList.add('is-open');
                }
              });
            }
          }
        }
        syncCount();
        /* Repopulate the recommendations here, not only from open().
           refresh(true) reopens the drawer WITHOUT going through open() (see
           the add-to-cart path below), and this innerHTML swap restores the
           strip to its empty hidden state either way. Hanging the load off
           open() alone meant the strip appeared when the drawer was opened
           from the cart icon and was blank when it opened from add-to-cart -
           the more common path of the two. */
        SURFACES.drawer.retried = 0;
        loadRecs('drawer');
        return true;
      })
      .catch(function (e) {
        console.error('Cart drawer refresh failed', e);
        return false;
      });
  }

  function syncCount(cart) {
    if (cart) {
      document.querySelectorAll('.cart-count-badge').forEach(function (b) {
        b.textContent = cart.item_count;
        b.style.display = cart.item_count === 0 ? 'none' : '';
      });
      return;
    }
    fetchWithTimeout(root() + 'cart.js', { headers: { 'Accept': 'application/json' } }, 12000)
      .then(function (r) { return r.json(); })
      .then(function (cart) { syncCount(cart); }).catch(function () {});
  }

  function money(cents) {
    if (window.KPTheme && typeof KPTheme.formatMoney === 'function') return KPTheme.formatMoney(cents);
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: currency }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + currency; }
  }
  function escapeHtml(v) {
    return String(v || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[c];
    });
  }

  /* Patches the drawer in place from a fresh /cart.js response — quantities,
     line prices, discounts, the Total row, the shipping/threshold block and
     the header/nav badge counts — instead of discarding and rebuilding the
     whole drawer via the Section Rendering API. That full-HTML rebuild was
     the reason quantity changes needed buttons disabled during the request
     (nothing else guarded against clicking a row that was about to be torn
     down and replaced): a lightweight patch has no such window, so nothing
     needs to be disabled and no full reload is needed for this to work.

     Mirrors sections/main-cart.liquid's updateCart() row-matching: Shopify
     re-keys a line whenever its discount allocations change (e.g. a 10%-off
     kicking in at quantity 2), so rows are matched by variant id whenever the
     stored key no longer matches, and only a row with NO matching line at all
     is removed — never one that merely got re-keyed. */
  function patchDrawer(cart) {
    var ec = document.getElementById('kp-drawer-count');
    if (ec) ec.textContent = '(' + cart.item_count + ')';
    syncCount(cart);

    /* Sync the recommendation seed from this same cart snapshot, before
       anything reads it.

       data-seed/data-seed-type are written once by Liquid on server render
       and were never written by JS again - the qty/remove success path here
       calls patchDrawer, not refresh(), whenever the cart is non-empty, so
       removing the seed product left the strip's seed pointing at a product
       no longer in the bag. Both fields are on the cart's line item object
       already (product_type is read at line ~733 in this same file), so this
       is free - no extra request. */
    var recsBox = document.getElementById('kp-drawer-recs');
    if (recsBox) {
      var firstItem = (cart.items || [])[0];
      if (firstItem) {
        recsBox.setAttribute('data-seed', String(firstItem.product_id));
        recsBox.setAttribute('data-seed-type', firstItem.product_type || '');
        recsBox.setAttribute('data-seed-vendor', firstItem.vendor || '');
      } else {
        recsBox.removeAttribute('data-seed');
      }
    }

    var liveRows = [].slice.call(document.querySelectorAll('.kp-ditem'));
    var matched = [];
    (cart.items || []).forEach(function (item) {
      var row = null;
      for (var n = 0; n < liveRows.length; n++) {
        if (matched.indexOf(liveRows[n]) !== -1) continue;
        if (liveRows[n].getAttribute('data-key') === item.key) { row = liveRows[n]; break; }
      }
      if (!row) {
        for (var m = 0; m < liveRows.length; m++) {
          if (matched.indexOf(liveRows[m]) !== -1) continue;
          if (liveRows[m].getAttribute('data-variant-id') === String(item.variant_id)) { row = liveRows[m]; break; }
        }
      }
      if (!row) return;
      matched.push(row);
      if (row.getAttribute('data-key') !== item.key) {
        row.setAttribute('data-key', item.key);
        [].slice.call(row.querySelectorAll('[data-key]')).forEach(function (el) { el.setAttribute('data-key', item.key); });
        var d = row.querySelector('[data-key-discounts]'); if (d) d.setAttribute('data-key-discounts', item.key);
        var p = row.querySelector('[data-key-price]'); if (p) p.setAttribute('data-key-price', item.key);
        var op = row.querySelector('[data-key-original-price]'); if (op) op.setAttribute('data-key-original-price', item.key);
        var fp = row.querySelector('[data-key-final-price]'); if (fp) fp.setAttribute('data-key-final-price', item.key);
      }

      var qtyEl = row.querySelector('.kp-dqty span');
      if (qtyEl) {
        qtyEl.textContent = item.quantity;
        qtyEl.setAttribute('data-confirmed-qty', String(item.quantity));
      }
      var finalEl = row.querySelector('[data-key-final-price="' + item.key + '"]'); if (finalEl) finalEl.textContent = money(item.final_line_price);
      var priceWrap = row.querySelector('[data-key-price="' + item.key + '"]') || (finalEl && finalEl.parentElement);
      var origEl = row.querySelector('[data-key-original-price="' + item.key + '"]');
      var showWas = item.original_line_price > item.final_line_price && money(item.original_line_price) !== money(item.final_line_price);
      if (!showWas) { if (origEl) origEl.remove(); }
      else if (origEl) { origEl.textContent = money(item.original_line_price); origEl.removeAttribute('hidden'); }
      else if (priceWrap && finalEl) {
        origEl = document.createElement('s');
        origEl.setAttribute('data-key-original-price', item.key);
        origEl.textContent = money(item.original_line_price);
        priceWrap.insertBefore(origEl, finalEl);
      }
      var discEl = row.querySelector('[data-key-discounts="' + item.key + '"]');
      if (discEl) {
        var allocs = item.line_level_discount_allocations || [];
        discEl.hidden = allocs.length === 0;
        discEl.innerHTML = allocs.map(function (a) {
          var t = a.discount_application && a.discount_application.title;
          return '<span>' + escapeHtml(t) + ' · −' + escapeHtml(money(a.amount)) + '</span>';
        }).join('');
      }
      row.classList.remove('kp-ditem--pending');
    });
    liveRows.forEach(function (row) { if (matched.indexOf(row) === -1) row.remove(); });

    if (cart.item_count === 0) { refresh(false); return; }

    var totalBox = document.querySelector('.kp-dsub');
    var kth = totalBox ? parseInt(totalBox.getAttribute('data-kpd-threshold'), 10) || 0 : 0;
    var kcost = totalBox ? parseInt(totalBox.getAttribute('data-kpd-cost-minor'), 10) || 0 : 0;
    var shipAdd = (kth > 0 && cart.total_price < kth) ? kcost : 0;
    var totalEl = document.getElementById('kp-drawer-total'); if (totalEl) totalEl.textContent = money(cart.total_price + shipAdd);

    /* The instalment line under the total restates it as "3 x £X". It is
       rendered server-side, so without this it keeps quoting the pre-change
       figure after a qty edit — a wrong price claim at the decision moment.
       Math.ceil matches the Liquid render's ceiling division, so the first
       paint and every repaint agree to the penny. Rounding DOWN (the old
       behaviour) quoted 3 x £371.66 = £1,114.98 against a £1,115.00 total —
       an instalment the customer would never actually be offered. */
    var origTotalEl = document.getElementById('kp-drawer-original-total');
    if (origTotalEl) {
      origTotalEl.textContent = money(cart.original_total_price + shipAdd);
      origTotalEl.hidden = !(cart.original_total_price + shipAdd > cart.total_price + shipAdd);
    }
    var saveBox = document.getElementById('kp-drawer-saving'), saveAmt = document.getElementById('kp-drawer-saving-amount');
    if (saveBox && saveAmt) {
      var diff = cart.original_total_price - cart.total_price;
      saveAmt.textContent = money(diff); saveBox.hidden = !(diff > 0);
    }

    var ship = document.querySelector('.kp-dship');
    if (ship && kth > 0) {
      var label = ship.getAttribute('data-kpd-label') || '';
      var cost = ship.getAttribute('data-kpd-cost') || '';
      if (cart.total_price >= kth) {
        ship.innerHTML = '<p class="kp-ship__win"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg><span>You’ve unlocked ' + escapeHtml(label) + '</span></p>';
      } else {
        var rem = kth - cart.total_price, pct = Math.min(100, (cart.total_price * 100) / kth);
        ship.innerHTML = '<p class="kp-ship__txt">You’re <strong>' + escapeHtml(money(rem)) + '</strong> away from <strong>' + escapeHtml(label) + '</strong></p><div class="kp-ship__bar"><div class="kp-ship__fill" style="width: ' + pct + '%"></div></div><p class="kp-ship__sub">Standard delivery ' + escapeHtml(cost) + '</p>';
      }
    }

    /* Mirrors sections/cart-drawer.liquid's has_quick/has_slow split so the
       "ships in more than one delivery" note stays correct after a qty
       change instead of only updating on the next full re-render. Same
       five product-type checks, same slow-shipping category list. */
    var noteEl = document.querySelector('.kp-dsub__note');
    if (noteEl) {
      var hasQuick = false, hasSlow = false;
      (cart.items || []).forEach(function (item) {
        var t = (item.product_type || '').toLowerCase();
        if (t.indexOf('wall bed') !== -1 || t.indexOf('bunk') !== -1 || t.indexOf('loft') !== -1 || t.indexOf('sleeper') !== -1 || t.indexOf('sofa') !== -1) {
          hasSlow = true;
        } else {
          hasQuick = true;
        }
      });
      var taxLabel = noteEl.getAttribute('data-kpd-tax-label') || '';
      noteEl.textContent = '· ' + taxLabel + (hasQuick && hasSlow ? ' · ships in more than one delivery' : '') + '.';
    }
  }

  /* One cart mutation at a time globally. Rapid clicks update each line's
     `desired` value and queued work sends only the latest quantity. Serializing
     across the whole cart matters because every response contains a full cart
     snapshot; two different lines must not race and paint stale snapshots. */
  var lineChangeStates = new WeakMap();
  var pendingLineChanges = [];
  var activeLineChange = null;

  function processLineChanges() {
    if (activeLineChange) return;
    var state = pendingLineChanges.shift();
    if (!state) return;
    state.queued = false;
    if (!state.row.isConnected) {
      processLineChanges();
      return;
    }

    var key = state.row.getAttribute('data-key');
    var sentQuantity = state.desired;
    activeLineChange = state;
    state.inFlight = true;
    state.row.setAttribute('aria-busy', 'true');
    state.row.classList.add('kp-ditem--pending');
    showCartFeedback('', 'error');
    track('cart_change_attempt', {
      variant_id: state.row.getAttribute('data-variant-id'),
      quantity: sentQuantity,
      action: sentQuantity === 0 ? 'remove' : 'update'
    });

    fetchWithTimeout(root() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: sentQuantity })
    }, 12000)
      .then(function (r) { if (!r.ok) throw new Error('change ' + r.status); return r.json(); })
      .then(function (cart) {
        patchDrawer(cart);
        /* Repopulate after the seed sync above. Adds no state of its own -
           the populated-guard in loadRecs (:138) means an unchanged seed with
           cards already painted returns before any fetch, so a normal
           quantity click costs nothing; a removal that empties the strip (or
           changes the seed) is exactly the case this exists for. */
        loadRecs('drawer');
        var confirmedItem = (cart.items || []).find(function (line) { return line.key === key; });
        state.confirmed = confirmedItem ? confirmedItem.quantity : 0;
        var confirmedEl = state.row.querySelector('.kp-dqty span');
        if (confirmedEl) confirmedEl.setAttribute('data-confirmed-qty', String(state.confirmed));
        track('cart_change_success', {
          variant_id: state.row.getAttribute('data-variant-id'),
          quantity: sentQuantity,
          cart_item_count: cart.item_count
        });
        state.inFlight = false;
        activeLineChange = null;
        state.row.removeAttribute('aria-busy');

        if (state.row.isConnected && state.desired !== sentQuantity) {
          var qtyEl = state.row.querySelector('.kp-dqty span');
          if (qtyEl) qtyEl.textContent = state.desired;
          queueLineState(state);
        } else {
          state.row.classList.remove('kp-ditem--pending');
        }
        processLineChanges();
      })
      .catch(function (e) {
        console.error('Cart update failed', e);
        track('cart_change_failure', {
          variant_id: state.row.getAttribute('data-variant-id'),
          quantity: sentQuantity
        });
        state.inFlight = false;
        activeLineChange = null;
        state.row.removeAttribute('aria-busy');
        state.row.classList.remove('kp-ditem--pending');
        showCartFeedback(themeStrings.cartError, 'error');

        /* The optimistic quantity is now unconfirmed. Reconcile from the
           server and require a deliberate new click rather than auto-retrying
           an ambiguous mutation. */
        fetchWithTimeout(root() + 'cart.js', { headers: { 'Accept': 'application/json' } }, 12000)
          .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
          .then(function (cart) {
            patchDrawer(cart);
            if (!state.row.isConnected) return;
            var keyNow = state.row.getAttribute('data-key');
            var item = (cart.items || []).find(function (line) { return line.key === keyNow; });
            var reconciled = item ? item.quantity : 0;
            state.desired = reconciled;
            state.confirmed = reconciled;
          })
          .catch(function () {
            /* The reconcile fetch also failed, so the row is still showing
               the optimistic quantity that was never confirmed. Falling back
               to state.confirmed (the last server-accepted value, or the
               value on screen before this change began) instead of leaving
               the unconfirmed number up — otherwise the next tap would step
               from a quantity Shopify never actually accepted. */
            if (state.row.isConnected) {
              var qtyEl = state.row.querySelector('.kp-dqty span');
              if (qtyEl) {
                qtyEl.textContent = state.confirmed;
                qtyEl.setAttribute('data-confirmed-qty', String(state.confirmed));
              }
            }
            state.desired = state.confirmed;
          })
          .finally(processLineChanges);
      });
  }

  function queueLineState(state) {
    if (!state || state.queued || state.inFlight) return;
    state.queued = true;
    pendingLineChanges.push(state);
    processLineChanges();
  }

  function queueLineChange(row, qty) {
    /* Quantity and removals mutate the bag too - a removed product becomes
       recommendable again, an added one must stay excluded. */
    invalidateRecsCache();
    var state = lineChangeStates.get(row);
    if (!state) {
      var qtyElNow = row.querySelector('.kp-dqty span');
      var confirmedAttr = qtyElNow && qtyElNow.getAttribute('data-confirmed-qty');
      var startQty = confirmedAttr != null && confirmedAttr !== ''
        ? parseInt(confirmedAttr, 10) || 0
        : (qtyElNow ? parseInt(qtyElNow.textContent, 10) || 0 : 0);
      state = { row: row, desired: qty, confirmed: startQty, inFlight: false, queued: false };
      lineChangeStates.set(row, state);
    } else {
      state.desired = qty;
    }
    var qtyEl = row.querySelector('.kp-dqty span');
    if (qtyEl) qtyEl.textContent = qty;
    queueLineState(state);
  }

  /* Intercept add-to-cart so the shopper keeps their place instead of
     being navigated to /cart. The native form remains the no-JS fallback;
     an ambiguous fetch failure is never automatically resubmitted because
     that could add the same line twice. */
  /* Warm the recommendations before the drawer is asked for.

     The cards are cached per seed product, but that cache starts empty on
     every page load - so the FIRST open on any page always waited for the
     fetch, and the strip appeared a few hundred ms late. That late arrival is
     the pop; no amount of fading hides it, because the cards genuinely do not
     exist yet.

     Fetching on intent instead of on open removes the wait without putting a
     request on every pageview: a pointer heading for the cart icon, a touch
     starting on it, or an add-to-cart being submitted all mean the drawer is
     about to be seen. The in-flight latch makes repeat triggers free, and the
     data is keyed to the cart's first line, which has not changed yet at the
     moment any of these fire. */
  function warmRecs() {
    if (document.getElementById('kp-drawer-recs')) loadRecs('drawer');
  }
  document.addEventListener('pointerenter', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('a[href$="/cart"], a[href*="/cart?"]')) warmRecs();
  }, true);
  document.addEventListener('touchstart', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('a[href$="/cart"], a[href*="/cart?"]')) warmRecs();
  }, { passive: true, capture: true });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    /* In parallel with cart/add.js, so the cards are ready by the time
       refresh() has swapped the panel in. */
    warmRecs();
    if (form.dataset.cartSubmitting === 'true') return;
    form.dataset.cartSubmitting = 'true';
    /* Prefer [name="add"] (main buy panels). Fall back to submit so sticky ATC
       and any future form without that attribute still get press feedback. */
    var btn = form.querySelector('[name="add"]') || form.querySelector('button[type="submit"]');
    var label = btn ? btn.innerHTML : null;
    // Swap only the label span so a sibling price span is never destroyed.
    var labelEl = btn && btn.querySelector('[data-variant-label]');
    var labelText = labelEl ? labelEl.textContent : null;
    if (btn) btn.classList.add('is-pressed');
    // A mid-request variant switch means product-controller.js already
    // updated label/price/disabled live; finally() must not stomp that.
    var variantChangedDuringAdd = false;
    function markVariantChanged() { variantChangedDuringAdd = true; }
    document.addEventListener('variant:change', markVariantChanged);
    showFormFeedback(form, '', 'error');
    if (btn) {
      btn.disabled = true;
      if (labelEl) labelEl.textContent = themeStrings.adding;
      else btn.textContent = themeStrings.adding;
    }
    var variantInput = form.querySelector('[name="id"]');
    var quantityInput = form.querySelector('[name="quantity"]');
    var addContext = {
      variant_id: variantInput && variantInput.value,
      quantity: quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1
    };
    track('cart_add_attempt', addContext);
    fetchWithTimeout(root() + 'cart/add.js', {
      method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form)
    }, 12000)
      .then(function (r) {
        if (!r.ok) {
          return r.json().catch(function () { return {}; }).then(function (data) {
            var error = new Error(data.description || themeStrings.addError);
            error.isShopifyResponse = true;
            error.userMessage = data.description || themeStrings.addError;
            throw error;
          });
        }
        return r.json();
      })
      .then(function (addedItem) {
        /* SKU AND PRICE FROM THE RESPONSE, not from page context (21 Aug 2026).
           track() backfills product_sku from body.dataset.productSku, which
           only exists on product pages - so drawer and collection quick-adds
           dispatched cart_add_success WITHOUT a sku, and both kp-meta-pixel.js
           and kp-remarketing.js guard on product_sku and silently skipped
           them: no Meta AddToCart, no Google remarketing add_to_cart, for any
           add that did not happen on a PDP. The /cart/add.js response this
           handler already parses carries the definitive answer - and on PDPs
           it is MORE correct than the dataset, which holds the default
           variant's sku even after the shopper switches colour.
           price is in minor units (pence); the listeners expect pounds. */
        track('cart_add_success', {
          variant_id: addedItem.variant_id || addContext.variant_id,
          quantity: addedItem.quantity || addContext.quantity,
          product_sku: addedItem.sku || undefined,
          product_price: (typeof addedItem.price === 'number')
            ? (addedItem.price / 100).toFixed(2) : undefined
        });
        /* refresh(true) reopens without going through open(), so set the
           focus-restoration target here instead: the button just used. */
        lastTrigger = btn || lastTrigger;
        /* Cart mutated: any cached cards were computed against the old bag. */
        invalidateRecsCache();
        return refresh(true).then(function (refreshed) {
          if (!refreshed) {
            syncCount();
            showFormFeedback(form, themeStrings.addedRefreshError, 'info', true);
          }
        });
      })
      .catch(function (err) {
        console.error('Add to cart failed', err);
        track('cart_add_failure', {
          variant_id: addContext.variant_id,
          quantity: addContext.quantity,
          response_error: Boolean(err.isShopifyResponse)
        });
        showFormFeedback(
          form,
          err.isShopifyResponse ? err.userMessage : themeStrings.addUncertain,
          'error',
          !err.isShopifyResponse
        );
      })
      .finally(function () {
        delete form.dataset.cartSubmitting;
        document.removeEventListener('variant:change', markVariantChanged);
        if (!btn) return;
        btn.classList.remove('is-pressed');
        if (variantChangedDuringAdd) return;
        btn.disabled = false;
        if (labelEl) labelEl.textContent = labelText;
        else if (label !== null) btn.innerHTML = label;
      });
  });

  /* Keep the card price honest when the shopper changes the variant - a card
     still reading "From GBP109.99" after they pick the GBP129.99 memory-foam
     option is a price the drawer is quoting and will not charge. */
  /* Cart page strip: no drawer open event to hang off, so load it once the
     page is ready. */
  function initCartRecs() { if (document.getElementById('kp-cart-recs')) loadRecs('cart'); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartRecs);
  } else { initCartRecs(); }
  /* External refresh hook. The chat assistant (kp-chat.js) adds to the cart
     via /cart/add.js, which updates the server but nothing on screen — the
     header badge and this drawer only knew about the theme's own add flows,
     so a chat add looked like it had silently failed. Any code that mutates
     the cart out-of-band can dispatch this. detail.open: true also slides the
     drawer open. */
  document.addEventListener('kp:cart-refresh', function (e) {
    refresh(!!(e && e.detail && e.detail.open));
  });

  document.addEventListener('kp:cart-recommendations-refresh', function () {
    invalidateRecsCache();
    SURFACES.cart.seed = null;
    SURFACES.cart.retried = 0;
    SURFACES.cart.loading = null;
    loadRecs('cart');
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('.kp-drec__variant');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var priceEl = sel.closest('.kp-drec').querySelector('.kp-drec__price');
    if (opt && priceEl && opt.dataset.price) priceEl.textContent = money(parseInt(opt.dataset.price, 10));
  });

  /* Back-forward cache restore. Returning from Shopify's checkout with the
     browser Back button replays the page from bfcache: no load event, no
     re-render, and any layout measured at the old viewport is still in place.
     That is the state to re-sync - the sticky-bar and recommendation logic
     both key off measurements taken when the panel was last laid out. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    SURFACES.drawer.seed = null; SURFACES.drawer.retried = 0;
    SURFACES.cart.seed = null;
    syncCount();
    if (document.querySelector('#kp-drawer.is-open')) loadRecs('drawer');
    if (document.getElementById('kp-cart-recs')) loadRecs('cart');
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-close]') || e.target.closest('#kp-drawer-overlay')) { close(); return; }
    var q = e.target.closest('[data-drawer-qty]');
    if (q) {
      var row = q.closest('.kp-ditem'); if (!row) return;
      var qtyEl = row.querySelector('.kp-dqty span');
      var cur = parseInt(qtyEl.textContent, 10) || 0;
      var next = cur + parseInt(q.dataset.drawerQty, 10);
      if (next < 0) next = 0;
      /* Shown immediately rather than waiting for the network round trip, so
         a click always reads as registered the instant it happens.
         patchDrawer() reconciles this against the server's real response —
         no disabling needed, because nothing here tears the row down and
         rebuilds it; there's no window where clicking again would hit a
         stale element. */
      queueLineChange(row, next); return;
    }
    /* Add from the cross-sell strip. Reuses the same cart/add.js +
       refresh path as the PDP so line-level discounts, delivery ETAs and the
       free-delivery bar all recompute; the strip itself is not re-rendered by
       patchDrawer, so refresh() is what brings the new line in. */
    var recAdd = e.target.closest('[data-rec-add]');
    if (recAdd && !recAdd.disabled) {
      /* Read the select at click time. data-rec-add still holds variants[0]
         as the fallback for cards with no select at all. */
      var recCard = recAdd.closest('.kp-drec');
      var recSel = recCard && recCard.querySelector('.kp-drec__variant');
      var recVariantId = recSel ? recSel.value : recAdd.dataset.recAdd;
      recAdd.disabled = true;
      var wasLabel = recAdd.textContent;
      recAdd.textContent = 'Adding\u2026';
      fetchWithTimeout(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(recVariantId, 10), quantity: 1 }] })
      }, 12000)
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function (data) {
          /* Same SKU/price hand-off as the form add above. This path was
             the leftover: it added the line and refreshed the drawer but
             never dispatched cart_add_success, so Meta and Google never
             saw drawer cross-sell adds. items[] is how /cart/add.js
             answers a bulk payload. */
          var added = (data && data.items && data.items[0]) || data || {};
          track('cart_add_success', {
            variant_id: added.variant_id || recVariantId,
            quantity: added.quantity || 1,
            product_sku: added.sku || undefined,
            product_price: (typeof added.price === 'number')
              ? (added.price / 100).toFixed(2) : undefined
          });
          invalidateRecsCache();
          SURFACES.drawer.seed = null; SURFACES.drawer.retried = 0; SURFACES.cart.seed = null;
          /* On the cart page the reload rebuilds everything, so firing
             refresh() first only raced a page teardown with a section fetch,
             its innerHTML swap and a loadRecs('drawer') that could never be
             seen. One path or the other, never both. */
          if (document.getElementById('kp-cart-recs')) { location.reload(); }
          else {
            return refresh(false).then(function (ok) {
              if (!ok) showCartFeedback(themeStrings.addedRefreshError, 'info');
            });
          }
        })
        .catch(function () {
          if (recAdd.isConnected) {
            recAdd.disabled = false;
            recAdd.textContent = wasLabel;
          }
          showCartFeedback('Sorry, that could not be added.', 'error');
        })
        .finally(function () {
          if (!recAdd.isConnected) return;
          recAdd.disabled = false;
          recAdd.textContent = wasLabel;
        });
      return;
    }

    var rm = e.target.closest('[data-drawer-remove]');
    if (rm) {
      var removeRow = rm.closest('.kp-ditem');
      if (removeRow) queueLineChange(removeRow, 0);
      return;
    }
    /* Header cart icon opens the drawer instead of loading /cart — except
       when we are already ON the cart page, where opening a drawer over the
       same content is just noise. There the link behaves normally. */
    var onCartPage = /\/cart\/?$/.test(window.location.pathname);
    var link = e.target.closest('a[href$="/cart"], a[href*="/cart?"]');
    if (link && !onCartPage && !e.metaKey && !e.ctrlKey && !link.closest('#kp-drawer')) {
      e.preventDefault();
      /* Open with whatever's already rendered — it's already correct as of
         the last add/change, since every mutation on this page patches the
         drawer's DOM directly (see patchDrawer below). Waiting on a fresh
         ?section_id fetch before the panel even slides in was the entire
         cause of the "opens slowly" complaint: on a real phone connection
         that round trip is easily visible, and blocking the whole open
         animation on it bought nothing — refresh(true) already reconciles
         the DOM again once the fetch lands, same as it always did, just
         without gating first paint on the network. */
      open(link);
      refresh(false).then(function (refreshed) {
        if (!refreshed) showCartFeedback(themeStrings.cartError, 'error');
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    var d = drawer();
    if (!d || !d.classList.contains('is-open')) return;

    if (e.key === 'Escape') { close(); return; }

    if (e.key === 'Tab') {
      var focusables = getFocusable(d);
      if (!focusables.length) return;
      var first = focusables[0], last = focusables[focusables.length - 1];
      var withinDrawer = d.contains(document.activeElement);
      if (e.shiftKey) {
        if (!withinDrawer || document.activeElement === first) {
          e.preventDefault(); last.focus();
        }
      } else {
        if (!withinDrawer || document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      }
    }
  });
})();
